import { NgLetDirective } from './ng-let.directive';
import { InfiniteScrollLoadingDirective } from './InfiniteScrollLoadingDirective';
import { NgModule } from '@angular/core';
import { ScrollHideDirective } from './ScrollHideDirective';
import { AutoFitTitleDirective } from './AutoFitTitleDirective';

@NgModule({
	declarations: [
		InfiniteScrollLoadingDirective,
		// HideHeaderDirective,
		ScrollHideDirective,
		NgLetDirective,
		AutoFitTitleDirective,
	],
	exports: [
		InfiniteScrollLoadingDirective,
		// HideHeaderDirective,
		ScrollHideDirective,
		NgLetDirective,
		AutoFitTitleDirective,
	]
})
export class DirectivesModule {}
